import { get } from 'lessons/repository/get'

export const repository = { get }
